import React, { useMemo } from 'react'
import styled, { css } from 'styled-components'
import { LoadingButton } from '@olxbr/ds-core'
import PropTypes from 'prop-types'

const ThemedButton = styled(LoadingButton)`
  ${({ color }) =>
    color === 'purple' &&
    css`
      --button-primary-background-color-base: var(--color-secondary-100);
      --button-primary-border-color-base: var(--color-secondary-100);
      --button-primary-background-color-hover: var(--color-secondary-110);
      --button-primary-border-color-hover: var(--color-secondary-110);
      --button-secondary-border-color-base: var(--color-secondary-100);
      --button-secondary-color-font-base: var(--color-secondary-100);
      --button-secondary-background-color-hover: var(--color-secondary-70);
      --button-secondary-border-color-hover: var(--color-secondary-110);
    `}
`

const injectButtonActions = ({
  action,
  href,
  shouldDisableSubmit,
  isSubmitting,
  onSubmit,
  lurker,
  tracking,
}) => {
  if (action === 'login') {
    return {
      disabled: shouldDisableSubmit,
      isLoading: isSubmitting,
      onClick: onSubmit,
      type: 'submit',
    }
  }
  if (action === 'redirect') {
    return {
      disabled: isSubmitting,
      onClick: () => {
        tracking?.OBJECT_DETAIL && lurker?.clickBeaconEvt(tracking.OBJECT_DETAIL)
        window.open(href, '_self')
      },
      type: 'button',
    }
  }
}

const LoginActionButton = ({
  shouldDisableSubmit,
  isSubmitting,
  onSubmit,
  icon: Icon,
  text,
  color,
  variant,
  action,
  href,
  tracking,
  lurker,
}) => {
  const buttonActions = useMemo(
    () =>
      injectButtonActions({
        action,
        href,
        lurker,
        tracking,
        isSubmitting,
        onSubmit,
        shouldDisableSubmit,
      }),
    [action, href, isSubmitting, onSubmit, shouldDisableSubmit, tracking, lurker]
  )

  return (
    <ThemedButton
      key={text}
      className="w-full"
      color={color}
      variant={variant}
      size="medium"
      {...buttonActions}
    >
      {Icon ? <Icon /> : null}
      {text}
    </ThemedButton>
  )
}

LoginActionButton.propTypes = {
  shouldDisableSubmit: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  onSubmit: PropTypes.func,
  icon: PropTypes.elementType,
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
  variant: PropTypes.string,
  action: PropTypes.oneOf(['login', 'redirect']).isRequired,
  href: PropTypes.string,
  tracking: PropTypes.object,
  lurker: PropTypes.object,
}

export default LoginActionButton
